import { Check, X } from "lucide-react";
import { Chapter, MaskedLine, Reveal } from "../components/motion";
import { config } from "../config/siteConfig";

const WhoFor = () => (
  <section
    id="who-for"
    data-testid="who-for-section"
    className="bg-[#F7F8FA] text-[#08162B] py-24 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter index="06" label="Who This Is For" />

      <h2 className="mt-10 font-display tracking-[0.02em] leading-[1.02] text-[clamp(2.2rem,5.5vw,4.5rem)]">
        <MaskedLine delay={0.1}>THIS BOOK IS FOR YOU IF...</MaskedLine>
      </h2>

      <div className="mt-14 grid sm:grid-cols-2 gap-4">
        {config.forYou.map((item, i) => (
          <Reveal key={item} delay={(i % 2) * 0.08 + Math.floor(i / 2) * 0.04} y={18}>
            <div
              data-testid={`for-you-card-${i + 1}`}
              className="flex items-start gap-4 bg-white border border-[#08162B]/10 p-6 h-full"
            >
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center bg-[#08162B] text-white">
                <Check size={13} strokeWidth={3} />
              </span>
              <p className="text-lg sm:text-xl leading-relaxed text-[#08162B]/85">{item}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-14">
        <div
          data-testid="not-for-you-panel"
          className="bg-[#08162B] text-white p-8 sm:p-12 lg:p-16"
        >
          <h3 className="font-sans font-extrabold uppercase tracking-tight text-2xl sm:text-4xl">
            THIS BOOK PROBABLY ISN'T FOR YOU IF...
          </h3>
          <div className="mt-10 grid sm:grid-cols-2 gap-x-10 gap-y-5">
            {config.notForYou.map((item, i) => (
              <div key={item} data-testid={`not-for-you-${i + 1}`} className="flex items-start gap-4">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center border border-white/30 text-white/70">
                  <X size={13} strokeWidth={3} />
                </span>
                <p className="text-lg sm:text-xl leading-relaxed text-white/65">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhoFor;
